import React from "react";

interface TextInputProps {
  text: string;
  onTextChange: (text: string) => void;
  onPrimaryKeywordChange: (keyword: string) => void;
  onSecondaryKeyword1Change: (keyword: string) => void;
  onSecondaryKeyword2Change: (keyword: string) => void;
  onSubmit: (calculatePlacement?: boolean) => void;
  primaryKeyword: string;
  secondaryKeyword1: string;
  secondaryKeyword2: string;
}

const TextInput: React.FC<TextInputProps> = ({
  text,
  onTextChange,
  onPrimaryKeywordChange,
  onSecondaryKeyword1Change,
  onSecondaryKeyword2Change,
  onSubmit,
  primaryKeyword,
  secondaryKeyword1,
  secondaryKeyword2,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div>
        <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Text Input</label>
        <textarea
          placeholder="Enter text to analyze"
          value={text}
          onChange={(e) => onTextChange(e.target.value)}
          style={{
            width: "100%",
            padding: "0.75rem",
            border: "1px solid #ddd",
            borderRadius: "4px",
            minHeight: "200px",
            resize: "vertical",
          }}
        />
      </div>

      <div>
        <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Primary Keyword</label>
        <input
          type="text"
          value={primaryKeyword}
          onChange={(e) => onPrimaryKeywordChange(e.target.value)}
          placeholder="e.g., digital marketing"
          style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px" }}
        />
      </div>

      <div style={{ display: "flex", gap: "1rem",flexWrap: "wrap", flexDirection: window.innerWidth <= 768 ? "column" : "row", }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Secondary Keyword 1</label>
          <input
            type="text"
            value={secondaryKeyword1}
            onChange={(e) => onSecondaryKeyword1Change(e.target.value)}
            placeholder="e.g., SEO optimization"
            style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px" }}
          />
        </div>

        <div style={{ flex: 1 }}>
          <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Secondary Keyword 2</label>
          <input
            type="text"
            value={secondaryKeyword2}
            onChange={(e) => onSecondaryKeyword2Change(e.target.value)}
            placeholder="e.g., content marketing"
            style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px" }}
          />
        </div>
      </div>

      <button
        onClick={() => onSubmit()}
        disabled={!text.trim()}
        style={{
          padding: "0.75rem 1.5rem",
          backgroundColor: !text.trim() ? "#ccc" : "#6b9a30",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Check Keyword Density
      </button>
    </div>
  );
};

export default TextInput;
